import { Component, OnInit} from '@angular/core';
import { ParentFrameNavigationService } from './@core/services/parent-frame-navigation.service';
import { UpshopParentSessionBridgeService } from './@core/services/upshop-parent-session-bridge.service';

@Component({
  selector: 'sk-cc',
  templateUrl: 'app.html',
})
export class AppComponent implements OnInit {

  constructor(
    _parentFrameNav: ParentFrameNavigationService,
    _upshopParentSessionBridge: UpshopParentSessionBridgeService,
  ) {
  }

  ngOnInit(): void {
  }
}
